import type {ReactElement} from 'react';
import {Icon} from '@Components/icon-v2';
import {IconSize} from '@Components/icon-v2/icon.types';
import type {AttachmentRemoveButtonProps} from './attachment-remove-button.types';
import styles from './attachment-remove-button.module.scss';

export function AttachmentRemoveButton({onClick}: AttachmentRemoveButtonProps): ReactElement {
  const label = window.i18next.t('pmwjs_ai_chat_remove_attachment');

  return (
    <button type="button" className={styles.removeButton} onClick={onClick} aria-label={label} title={label}>
      <Icon icon="icon-close" size={IconSize.SIZE_ICON_8} ariaHidden />
    </button>
  );
}
